import { ColumnDef } from '@tanstack/react-table'
import { INaturalPerson, IRenderInputs } from '../models/models'
import Status from '../components/UI/Status'
import dateFormat from 'dateformat'
import { formatPhone } from '../helpers'

export const naturalPersonsColumns: ColumnDef<INaturalPerson>[] = [
	{
		accessorKey: 'userId',
		header: 'id клієнта',
	},
	{
		accessorKey: 'status',
		header: 'Статус',
		cell: (value) => <Status type={value.getValue<any>()} />,
	},
	{
		accessorKey: 'fio',
		header: 'ПІБ',
		minSize: 300,
	},
	{
		accessorKey: 'phone',
		header: 'Номер телефону',
		enableSorting: false,
		cell: (value) => formatPhone(value.getValue<any>()) || '-',
	},
	{
		accessorKey: 'email',
		header: 'E-mail',
		enableSorting: false,
		minSize: 200,
	},
	{
		accessorKey: 'registeredAt',
		header: 'Дата реєстрації',
		cell: (value) => dateFormat(value.getValue<any>(), 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'inn',
		header: 'РНОКПП',
		enableSorting: false,
	},
	{
		accessorKey: 'passport',
		header: 'Паспортні дані',
		enableSorting: false,
	},
	{
		accessorKey: 'birthdate',
		header: 'Дата народження',
		cell: (value) => dateFormat(value.getValue<any>(), 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'registration',
		header: 'Адреса',
		enableSorting: false,
		minSize: 300,
	},
	{
		accessorKey: 'region',
		header: 'Регіон',
		cell: (value) => value.row.original.region.name,
	},
]

export interface naturalPersonsInputs {
	name: string
	lastname: string
	surname?: string | null
	email: string
	phone: string
	inn?: string | null
	birthdate?: any | null
	passport?: string | null
	registration?: string | null
	status?: boolean | null
	discountPerLiter?: number | null
}

export const naturalPersonsInputsData: IRenderInputs<naturalPersonsInputs>[] = [
	{
		name: 'lastname',
		type: 'text',
		placeholder: 'Прізвище',
	},
	{
		name: 'email',
		type: 'text',
		placeholder: 'E-mail',
	},
	{
		name: 'name',
		type: 'text',
		placeholder: 'Ім’я',
	},
	{
		name: 'phone',
		type: 'text',
		placeholder: 'Номер телефону',
	},
	{
		name: 'surname',
		type: 'text',
		placeholder: 'По-батькові',
	},
	{
		name: 'inn',
		type: 'text',
		placeholder: 'Номер РНКОПП',
	},
	{
		name: 'birthdate',
		type: 'date',
		placeholder: 'Дата народження',
	},
	{
		name: 'passport',
		type: 'text',
		placeholder: 'Паспортні дані',
	},
	{
		name: 'registration',
		type: 'text',
		placeholder: 'Прописка',
	},
	{
		name: 'discountPerLiter',
		type: 'number',
		step: 0.01,
		placeholder: 'Знижка грн/л',
	},
]
